import {getQueryParameters, serializeQueryParameters } from './utils';

export const getPromptPath = (assessmentName, searchParams, promptId, options={}) => {
    const uri = `/assessment/${assessmentName}/prompt/${promptId}`;
    searchParams = handleSearchParams(searchParams, options);
    return uri + searchParams;
}

export const getLoadingPath = (assessmentName, searchParams) => {
    const uri = `/assessment/${assessmentName}/loading`;
    return uri + searchParams;
}

export const getResultsPath = (assessmentName, searchParams, options={}) => {
    const uri = `/assessment/${assessmentName}/results`;
    searchParams = handleSearchParams(searchParams, options);
    return uri + searchParams;
}

const handleSearchParams = (searchParams, options) => {
    const { clearSearchParams } = options;

    if (clearSearchParams && clearSearchParams.length) {
        let queryParams = getQueryParameters(searchParams);

        for (const param of clearSearchParams) {
            delete queryParams[param];
        }

        if (Object.keys(queryParams).length > 0) {
            searchParams = '?' + serializeQueryParameters(queryParams);
        } else {
            searchParams = '';
        }
    }

    return searchParams;
}